export default __webpack_public_path__ + "d6f09960eb474921bc3b31d8f108fd4f.svg";